import { render, staticRenderFns } from "./DPOSVoteTable.vue?vue&type=template&id=61a80cf2&"
import script from "./DPOSVoteTable.vue?vue&type=script&lang=js&"
export * from "./DPOSVoteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports